var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 37,
    viewBox: "0 0 45 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8461 0C44.0021 0 44.8757 1.04207 44.6763 2.1791L43.5796 8.41493L40.8783 23.709C40.7216 24.5968 39.9502 25.2448 39.0481 25.2448H27.0417C25.5486 25.2448 24.6656 23.5713 25.5083 22.337L29.2754 16.8299L33.0426 11.3228C33.8852 10.0884 33.0022 8.41493 31.5091 8.41493H11.6147C10.4587 8.41493 9.58282 7.37048 9.78458 6.23346L10.6154 1.53581C10.7721 0.648033 11.5435 0 12.4456 0L42.8461 0Z",
    fill: "#007BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85864 36.9592C0.702628 36.9592 -0.170911 35.9172 0.0284838 34.7801L1.12515 28.5443L3.8241 13.2479C3.98077 12.3601 4.75224 11.7121 5.65426 11.7121H17.6607C19.1538 11.7121 20.0368 13.3856 19.1941 14.6199L15.427 20.127L11.6598 25.6341C10.8172 26.8684 11.7002 28.5419 13.1933 28.5419H33.09C34.246 28.5419 35.1219 29.5864 34.9202 30.7234L34.0894 35.421C33.9327 36.3088 33.1612 36.9569 32.2592 36.9569H1.85864V36.9592Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.52282326748208aed8721a632f5d2ba1.svg";
export { ForwardRef as ReactComponent };